import ContentPageTemplate from '@/components/ContentPageTemplate';
import { utilityPages } from '@/data/utilityPages';

export default function PrivacyPolicyPage() {
  return <ContentPageTemplate page={utilityPages['privacy-policy-page']} />;
}
